module.exports = __webpack_public_path__ + "static/img/xx_pic4.10ee93c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rizhi/xx_pic4.jpg
// module id = ZFti
// module chunks = 5